import type { VirtualizedComboboxOption } from '@roger/ui-components';

// IANA timezone names, sourced from the browser's ICU tzdata (Intl) rather
// than a hand-maintained list. The backend validates the chosen value against
// Python's zoneinfo/IANA tzdata independently on write.
interface IntlWithSupportedValuesOf {
  supportedValuesOf(input: 'timeZone'): string[];
}
const TIMEZONE_VALUES: string[] =
  typeof Intl !== 'undefined' && 'supportedValuesOf' in Intl
    ? (Intl as unknown as IntlWithSupportedValuesOf).supportedValuesOf(
        'timeZone'
      )
    : [];

// Human-readable label for an IANA timezone, e.g. "America/Los_Angeles" ->
// "America/Los Angeles", "America/Indiana/Indianapolis" ->
// "America/Indiana - Indianapolis".
export function formatTimezoneLabel(tz: string): string {
  const [prefix, ...rest] = tz.split('/');
  return `${prefix}/${rest.join(' - ').replace(/_/g, ' ')}`;
}

// All IANA zones are offered (matching backend validation, which accepts any
// valid IANA name) so US territories outside the America/ prefix, such as
// Pacific/Honolulu and Pacific/Guam, stay selectable.
export const TIMEZONE_OPTIONS: VirtualizedComboboxOption[] =
  TIMEZONE_VALUES.map(tz => ({
    value: tz,
    label: formatTimezoneLabel(tz),
  })).sort((a, b) => a.label.localeCompare(b.label));
